export default __webpack_public_path__ + "static/media/final.84b7d797.webp";